export const formatRewardRate = (rate: number) => `${rate.toFixed(1)}%`;

interface RewardRate {
  maxRewardRate?: number | null;
  rewardRateCount?: number | null;
}

export const resolveRewardRateLabel = ({
  maxRewardRate,
  rewardRateCount,
}: RewardRate) => {
  if (!rewardRateCount || typeof maxRewardRate !== 'number') {
    return null;
  }

  const rate = formatRewardRate(maxRewardRate);

  return rewardRateCount === 1 ? rate : `최대 ${rate}`;
};
